import { NetworkStatus, useMutation, useQuery } from '@apollo/client'

import {
  ConsolePost,
  ConsolePostQuery,
  ConsolePostQueryVariables,
  DeletePost,
  DeletePostMutation,
  DeletePostMutationVariables,
  PostStatus,
  PostType,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { data, fetchMore, refetch, networkStatus } = useQuery<
    ConsolePostQuery,
    ConsolePostQueryVariables
  >(ConsolePost, {
    variables: {
      artistId: user?.uid ?? '',
      status: [PostStatus.Scheduled],
    },
    notifyOnNetworkStatusChange: true,
  })
  const [deletePost, { loading: loadingDeletePost }] = useMutation<
    DeletePostMutation,
    DeletePostMutationVariables
  >(DeletePost)

  return {
    state: {
      userId: data?.user?.id || '',
      artistId: user?.uid ?? '',
      loadingDeletePost,
      artist: data?.artist ?? null,
      loading:
        networkStatus === NetworkStatus.loading ||
        networkStatus === NetworkStatus.refetch ||
        networkStatus === NetworkStatus.fetchMore,
      hasNextPage: !!data?.artist?.posts?.pageInfo.hasNextPage,
      posts: data?.artist?.posts ?? null,
    },
    actions: {
      async onFilter(resourceType) {
        await refetch({
          artistId: user?.uid ?? '',
          resourceType: resourceType.type as PostType,
          status: [PostStatus.Scheduled],
        })
      },
      async onFetchMore() {
        await fetchMore({
          variables: {
            artistId: user?.uid ?? '',
            status: [PostStatus.Scheduled],
            pageInput: {
              cursor: data?.artist?.posts?.pageInfo.endCursor,
            },
          },
        })
      },
      async onDeletePost(postId: string) {
        await deletePost({ variables: { postId: postId } })
      },
    },
  }
})
